import { FormLayout } from "@careinfo/layout";
import React from "react";
import Hubform from "./Hubform";
import { useForm } from "react-hook-form";

const CreateHub = (props: any) => {
  const { handleCreate, isLoading } = props;
  const {
    handleSubmit,
    setError,
    register,
    formState: { errors },
  } = useForm({});
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <Hubform register={register} errors={errors} />
    </FormLayout>
  );
};

export default CreateHub;
